"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _Authentication = require("./Authentication");
Object.keys(_Authentication).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Authentication[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Authentication[key];
    }
  });
});
var _AuthenticationConfiguration = require("./AuthenticationConfiguration");
Object.keys(_AuthenticationConfiguration).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _AuthenticationConfiguration[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _AuthenticationConfiguration[key];
    }
  });
});
var _AzureRegionHierarchyConfiguration = require("./AzureRegionHierarchyConfiguration");
Object.keys(_AzureRegionHierarchyConfiguration).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _AzureRegionHierarchyConfiguration[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _AzureRegionHierarchyConfiguration[key];
    }
  });
});
var _AzureRegionOrTenant = require("./AzureRegionOrTenant");
Object.keys(_AzureRegionOrTenant).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _AzureRegionOrTenant[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _AzureRegionOrTenant[key];
    }
  });
});
var _AzureRegions = require("./AzureRegions");
Object.keys(_AzureRegions).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _AzureRegions[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _AzureRegions[key];
    }
  });
});
var _ClientServiceUrl = require("./ClientServiceUrl");
Object.keys(_ClientServiceUrl).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ClientServiceUrl[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ClientServiceUrl[key];
    }
  });
});
var _ClientServiceUrls = require("./ClientServiceUrls");
Object.keys(_ClientServiceUrls).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ClientServiceUrls[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ClientServiceUrls[key];
    }
  });
});
var _ConfigurationManagerOptions = require("./ConfigurationManagerOptions");
Object.keys(_ConfigurationManagerOptions).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ConfigurationManagerOptions[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ConfigurationManagerOptions[key];
    }
  });
});
var _ConfigurationType = require("./ConfigurationType");
Object.keys(_ConfigurationType).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ConfigurationType[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ConfigurationType[key];
    }
  });
});
var _EnvironmentHierarchyConfiguration = require("./EnvironmentHierarchyConfiguration");
Object.keys(_EnvironmentHierarchyConfiguration).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _EnvironmentHierarchyConfiguration[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _EnvironmentHierarchyConfiguration[key];
    }
  });
});
var _AzureRegion = require("./generated/AzureRegion");
Object.keys(_AzureRegion).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _AzureRegion[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _AzureRegion[key];
    }
  });
});
var _Environment = require("./generated/Environment");
Object.keys(_Environment).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Environment[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Environment[key];
    }
  });
});
var _Service = require("./generated/Service");
Object.keys(_Service).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Service[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Service[key];
    }
  });
});
var _PickBaseServiceUrls = require("./PickBaseServiceUrls");
Object.keys(_PickBaseServiceUrls).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _PickBaseServiceUrls[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _PickBaseServiceUrls[key];
    }
  });
});
var _RequiredServices = require("./RequiredServices");
Object.keys(_RequiredServices).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _RequiredServices[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _RequiredServices[key];
    }
  });
});
var _ServiceRuntime = require("./ServiceRuntime");
Object.keys(_ServiceRuntime).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ServiceRuntime[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ServiceRuntime[key];
    }
  });
});
var _Services = require("./Services");
Object.keys(_Services).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Services[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Services[key];
    }
  });
});
var _ServiceUrls = require("./ServiceUrls");
Object.keys(_ServiceUrls).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ServiceUrls[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ServiceUrls[key];
    }
  });
});
var _StorageUrls = require("./StorageUrls");
Object.keys(_StorageUrls).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _StorageUrls[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _StorageUrls[key];
    }
  });
});
var _Tenant = require("./Tenant");
Object.keys(_Tenant).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Tenant[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Tenant[key];
    }
  });
});
var _TenantHierarchyConfiguration = require("./TenantHierarchyConfiguration");
Object.keys(_TenantHierarchyConfiguration).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _TenantHierarchyConfiguration[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _TenantHierarchyConfiguration[key];
    }
  });
});
var _Tenants = require("./Tenants");
Object.keys(_Tenants).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Tenants[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Tenants[key];
    }
  });
});
